import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  MenuItem,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, DELETE, PUT } from "../Generic/CrudRequest";
import ModalGeneric from "../Generic/ModalGeneric";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import { useTranslation } from "react-i18next";



export default function InspectionPoint(props) {
  const { t, i18n } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchText, setSearchText] = useState("");
  const [estatus, setEstatus] = React.useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [inpectionPointIdToDelete, setInpectionPointIdToDelete] =
    useState(null);
  const [inpectionPointIdToReactivar, setInpectionPointIdToReactivar] =
    useState(null);
  const [bodyModal, setBodyModal] = useState(null);
  const [caseModal, setCaseModal] = useState(0);
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);
  const [eliminated, setEliminated] = useState(false);
  const [restoring, setRestoring] = useState(false);
  const theme = useTheme();
  const { config } = props;
  const exportToExcel = useExcelExport();
  const handleExport = () => {
    exportToExcel(rows, columns, t("inspectionPoint.titleExcel"));
  };
  let desc = i18n.language === "en" ? "descripcionIngles" : "descripcion"
  const columns = [
    { id: desc, label: t("inspectionPoint.name"), minWidth: "100px" },
    { id: "estatus", label: t("inspectionPoint.status"), minWidth: "100px" },
  ];
  useEffect(() => {
    fetchInpectionPoint();
  }, [page, rowsPerPage, column, order]);

  const fetchInpectionPoint = async () => {
    const dataInpectionPoint = await GET(
      `${config.url}/api/InpectionPoint/paginado`,
      {
        start: page * rowsPerPage,
        length: rowsPerPage,
        nombre: searchText,
        status: estatus,
        column: column,
        dir: order,
      }
    );
    setRows(dataInpectionPoint.results);
    setTotalRecords(dataInpectionPoint.rowCount);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionRegister = searchPermissions(
      "PuntosInspeccion",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "PuntosInspeccion",
      "Editar",
      permissionsArray
    );

    const permissionEliminated = searchPermissions(
      "PuntosInspeccion",
      "Eliminar",
      permissionsArray
    );

    const permissionRestoring = searchPermissions(
      "PuntosInspeccion",
      "Restaurar",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
    setEliminated(permissionEliminated);
    setRestoring(permissionRestoring);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchInpectionPoint();
  };

  const handleClear = () => {
    setSearchText("");
    setEstatus(true);
  };

  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const deleteInpectionPoint = async (id) => {
    debugger
    await DELETE(`${config.url}/api/InpectionPoint/${id}`);
    fetchInpectionPoint();
  };

  const reactivarInpectionPoint = async (id) => {
    await PUT(
      `${config.url}/api/InpectionPoint/reactivar/?idPuntoInsPeccion=${id}`
    );
    fetchInpectionPoint();
  };

  const handleDeleteInpectionPoint = (userName, id) => {
    setIsModalOpen(true);
    setModalTitle(t("inspectionPoint.deleteConfirm.title"));
    setModalDescription(t("inspectionPoint.deleteConfirm.message", { name: userName }));
    setBodyModal(<></>);
    setInpectionPointIdToDelete(id);
    setCaseModal(1);
  };
  const handleReactivarInpectionPoint = (userName, id) => {
    setIsModalOpen(true);
    setModalTitle(t("inspectionPoint.reactivateConfirm.title"));
    setModalDescription(t("inspectionPoint.reactivateConfirm.message", { name: userName }));
    setBodyModal(<></>);
    setInpectionPointIdToReactivar(id);
    setCaseModal(2);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAcceptModal = () => {
    if (caseModal === 1) {
      deleteInpectionPoint(inpectionPointIdToDelete);
    } else if (caseModal === 2) {
      reactivarInpectionPoint(inpectionPointIdToReactivar);
    }
    setIsModalOpen(false);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      {isModalOpen && (
        <ModalGeneric
          open={isModalOpen}
          title={modalTitle}
          description={modalDescription}
          onClose={handleCloseModal}
          onAccept={handleAcceptModal}
          bodyComponent={bodyModal}
        />
      )}
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between", 
            overflow: "hidden", 
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("inspectionPoint.title")}
          </Typography>
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/PuntosInspeccion/Agregar"
              style={{
                marginLeft: "auto",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t("buttons.add")}
            />
          )}
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspectionPoint.name")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("inspectionPoint.status")}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                size="small"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t("units.active")}</MenuItem>
                <MenuItem value={false}>{t("units.inactive")}</MenuItem>
              </TextField>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.search")}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("buttons.clear")}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t("buttons.exportExcel")}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t("inspectionPoint.noInspectionPointsAvailable")}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {row[column.id] !== null && row[column.id] !== "" ? (
                            row[column.id] === true ? (
                              t("units.active")
                            ) : row[column.id] === false ? (
                              t("units.inactive")
                            ) : (
                              row[column.id]
                            )
                          ) : (
                            <i>{t("inspectionPoint.notAvailable")}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {row.estatus === true && edit && (
                          <Icons
                            iconName="Edit"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            to={`/PuntosInspeccion/Editar/${row.idPuntoInspeccion}`}
                            tooltip={t("buttons.edit")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {row.estatus === true && eliminated && (
                          <Icons
                            onClick={() =>
                              handleDeleteInpectionPoint(
                                row.descripcion,
                                row.idPuntoInspeccion
                              )
                            }
                            iconName="Delete"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.danger.main,
                              color: "#fff",
                            }}
                            tooltip={t("buttons.delete")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {row.estatus === false && restoring && (
                          <Icons
                            onClick={() =>
                              handleReactivarInpectionPoint(
                                row.descripcion,
                                row.idPuntoInspeccion
                              )
                            }
                            iconName="Restore"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            tooltip={t("buttons.restore")}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: t("pagination.all") }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("pagination.labelRowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              t("pagination.displayedRows", { from, to, count })
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
